import { dot, lift, line, path, rect, sparkle } from '../../../shared/howItWorksArt.js'

// The /contact header picture (founder 2026-10-15: "have a hero of somebody
// helping someone"). Website only, in the house style of shared/heroMomentArt.js:
// 160 by 120, flat, rounded, no outlines, each object lifted off the page by a
// `depth` layer. The people are drawn the way shared/addPeopleArt.js draws them
// (a white head and shoulders on a pastel disc).
//
// Someone helping someone: on the left a member of our team in a headset, on the
// right the visitor. The visitor's pink bubble asks, the team's mint bubble
// answers in front of it.
//
// ⛔ Colours are {{slot}}s from shared/pastelTones.js only: never turquoise (the
// logo) or the link blue (actions). Decorative: the page's words carry the meaning.

const person = (cx, cy, r, tone) => lift((f) => dot(cx, cy, r, f), tone, 3, 3)
  + dot(cx, cy - r * 0.24, r * 0.36, '{{white}}')
  + path(`M${cx - r * 0.58} ${cy + r * 0.72}a${r * 0.58} ${r * 0.48} 0 0 1 ${r * 1.16} 0z`)('{{white}}')

// The team member: lavender, head at (44, 68.5), with a headset over it.
const HELPER = person(44, 75, 27, '{{lavender}}')
  + line('M31 68.5a13 13 0 0 1 26 0', '{{ink}}', 3)
  + rect(28, 64.5, 5, 9, 2.5, '{{ink}}') + rect(55, 64.5, 5, 9, 2.5, '{{ink}}')
  + line('M30.5 73.5c0 4.5 4 7 9.5 7', '{{ink}}', 2.4) + dot(41, 80.5, 2.4, '{{ink}}')

const VISITOR = person(122, 84, 22, '{{yellow}}')

// The visitor's question: a pink bubble, three white dots, its tail to them.
const ASK = lift(
  (f) => rect(98, 12, 48, 26, 12, f) + path('M126 36l9 11 1-11z')(f),
  '{{pink}}', 3, 3,
) + dot(111, 25, 3.2, '{{white}}') + dot(122, 25, 3.2, '{{white}}') + dot(133, 25, 3.2, '{{white}}')

// The answer: a mint bubble in front, two lines of reply, its tail to the helper.
const ANSWER = lift(
  (f) => rect(56, 30, 52, 28, 12, f) + path('M64 56l-3 10 12-10z')(f),
  '{{mint}}', 3, 3,
) + rect(65, 39, 34, 5, 2.5, '{{white}}') + rect(65, 48, 22, 5, 2.5, '{{white}}')

const SPARKLES = sparkle(20, 28, 7, '{{yellow}}') + sparkle(150, 60, 5, '{{lavender}}')
  + sparkle(86, 104, 5, '{{softPink}}') + dot(36, 14, 2.6, '{{softPink}}') + dot(96, 86, 2.2, '{{lavender}}')

export const CONTACT_HERO_XML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 120">${VISITOR}${HELPER}${ASK}${ANSWER}${SPARKLES}</svg>`
